import React from "react";
import HeadTittle from "../../../components/HeadTittle";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {AddIcon, TrashOutlineIcon} from "../../../components/buttons/IconButtons";
import StepperTabs from "../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../components/StepperTabs/StepTab";
import DeleteModal from "../../Modals/DeleteModal";
import SearchFor from "../../Modals/SearchFor";
import ExportDataBtn from "../../../components/buttons/ExportDataBtn";
import SearchFilterBtn from "../../../components/buttons/SearchFilterBtn";
import routes from "../../../Routes/routes";
import {GuardsMainApp} from "./Functionality/GuardsMainApp";
import {GUARDS_TABS, TAB_PERMISSION_GUARDS} from "./Model/Model";
import GuardRoster from "./Roster/GuardRoster";
import ZoneAccessTable from "./ZoneAccess/ZoneAccessTable";

/**
 * Guards module, the roster of the guards and the zone accesses they are assigned to.
 */
const GuardsMain = () => {
    const {
        t,
        navigate,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        selectedList,
        setSelectedList,
        deleteModal,
        setDeleteModal,
        modified,
        setModified,
        permissionButtons,
        canReadRoster,
        canReadZoneAccess,
        goCreate,
        deleteSelected,
        canRead,
        moduleId,
        option,
        searchElement,
        setSearchElement,
        search,
        setSearch,
        bodyForExport,
        setBodyForExport,
        criteria,
        setCriteria,
        finalArray,
        setFinalArray,
        filterDialogShow,
        setFilterDialogShow,
        resetSearch,
    } = GuardsMainApp();

    if (!canRead) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle name={'guards'}>
                {permissionButtons(TAB_PERMISSION_GUARDS().EXPORT) &&
                    <ExportDataBtn
                        id='btn_gm_export'
                        moduleId={moduleId}
                        option={option}
                        search={search}
                        body={search ? criteria : bodyForExport}
                        searchElement={search ? undefined : searchElement}
                    />
                }
                {permissionButtons(TAB_PERMISSION_GUARDS().CREATE) &&
                    <ButtonAction
                        id='btn_gm_create'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={goCreate}
                    />
                }
                {permissionButtons(TAB_PERMISSION_GUARDS().DELETE) &&
                    <ButtonAction
                        id='btn_gm_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => setDeleteModal(true)}
                    />
                }
                {permissionButtons(TAB_PERMISSION_GUARDS().ADVANCE_SEARCH) &&
                    <SearchFilterBtn
                        finalArray={finalArray}
                        fnclick={() => {
                            if (selectedList?.length > 0) setSelectedList([]);
                            setFilterDialogShow(true);
                        }}
                    />
                }
            </HeadTittle>

            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={GUARDS_TABS.ROSTER.INDEX} activeStep={activeStep} normalHeight={true}>
                    {canReadRoster && activeStep === GUARDS_TABS.ROSTER.INDEX &&
                        <GuardRoster
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            modified={modified}
                            setModified={setModified}
                            goCreate={goCreate}
                            setDeleteModal={setDeleteModal}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSearch={setSearch}
                            setBodyForExport={setBodyForExport}
                            setCriteria={setCriteria}
                            finalArray={finalArray}
                            resetSearch={resetSearch}
                        />
                    }
                </StepTab>
                <StepTab index={GUARDS_TABS.ZONE_ACCESS.INDEX} activeStep={activeStep} normalHeight={true}>
                    {canReadZoneAccess && activeStep === GUARDS_TABS.ZONE_ACCESS.INDEX &&
                        <ZoneAccessTable
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            modified={modified}
                            setModified={setModified}
                            goCreate={goCreate}
                            setDeleteModal={setDeleteModal}
                            searchElement={searchElement}
                            setSearchElement={setSearchElement}
                            setSearch={setSearch}
                            setBodyForExport={setBodyForExport}
                            setCriteria={setCriteria}
                            finalArray={finalArray}
                        />
                    }
                </StepTab>
            </StepperTabs>

            <SearchFor
                open={filterDialogShow}
                onClose={() => setFilterDialogShow(false)}
                onFiltered={(originalArray) => {
                    setFilterDialogShow(false);
                    setFinalArray(originalArray);
                    setSearchElement(''); // clean search component
                }}
                moduleId={moduleId}
                option={option}
                finalArray={finalArray}
                cleanAdvance={modified}
                setCleanAdvance={setModified}
                search={search}
                setSearch={setSearch}
                setFinalArray={setFinalArray} // Used to clean all the filters of the advanced search
                searchElement={searchElement} // Used to detect the changes of the simple search
            />

            <DeleteModal
                show={deleteModal}
                onHide={() => setDeleteModal(false)}
                data={selectedList}
                onClickFn={() => {
                    deleteSelected(selectedList);
                    setDeleteModal(false);
                }}
                title_modal={t('delete')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t(activeStep === GUARDS_TABS.ZONE_ACCESS.INDEX ? 'zone_access' : 'guards')}
                isReset={() => setSelectedList([])}
            />
        </>
    );
};

export default GuardsMain;
